import {
  Component,
  OnInit,
  ViewChildren,
  ViewChild,
  QueryList,
  HostListener,
  AfterViewInit,
} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {Location} from '@angular/common';
import {environment} from '../../../../environments/environment';
import {HttpService} from '../../../core';
import {Observable} from 'rxjs';
import {MatDialog} from '@angular/material/dialog';
import {Constants} from '../../../core/services/constants.service';
import {ManualUpdateDialogComponent} from './manual-update-dialog/manual-update-dialog.component';
import {PhotoDialogComponent} from './photo-dialog/photo-dialog.component';
import {VideoDialogComponent} from './video-dialog/video-dialog.component';
import {MatTabGroup} from '@angular/material/tabs';
import {FloorplansComponent} from './floorplans/floorplans.component';
import {ProjectDetailTabService} from 'src/app/core/services/projectDetailTab.service';
import SwiperCore, {Navigation, Pagination} from 'swiper/core';
import {map} from 'rxjs/operators';
import {AddPropertyDialogComponent} from './properties/add-property-dialog/add-property-dialog.component';
import {EditProjectComponent} from '../edit/edit-project.component';
import {EditFloorplanDialogComponent} from './floorplans/edit-floorplan-dialog/edit-floorplan-dialog.component';
import {AddEoiDialog} from './eois/add-eoi-dialog/add-eoi-dialog';
import {AddDocumentDialogComponent} from './documents/add-document-dialog/add-document-dialog.component';
import {NewPackagesComponent} from '../edit/packages/new-packages/new-packages.component';
import {AddLotDialogComponent} from './lots/add-lot-dialog/add-lot-dialog.component';
import * as _moment from 'moment';

const moment = _moment;
// install Swiper modules
SwiperCore.use([Navigation, Pagination]);

@Component({
  selector: 'app-project-detail',
  templateUrl: './project-detail.component.html',
  styleUrls: ['./project-detail.component.scss'],
})
export class ProjectDetailComponent implements OnInit, AfterViewInit {
  @ViewChildren('childTabs') childTabs: QueryList<MatTabGroup>;
  @ViewChild(FloorplansComponent) FloorplansComponent: FloorplansComponent;
  @ViewChild(MatTabGroup) tabGroup!: MatTabGroup;

  VERIFICATION_CODE_URL = environment.VERIFICATION_CODE_URL;
  constants = Constants;
  geoCoder: any;
  lat: any;
  lng: any;
  momentDate: any;
  projectImages = [];
  projectId: any;
  project$: Observable<any>;
  project: any;
  logoUrl = '';
  SERVER_URL = environment.SERVER_URL;
  mode: any;
  dataSource: any;
  lots = [];
  displayedColumns = [
    'unit',
    'level',
    'price',
    'extraCost',
    'internalArea',
    'externalArea1',
    'externalArea2',
    'totalArea',
    'landArea',
    'type',
    'status',
    'bedRoom',
    'bathRoom',
    'car',
    'study',
    'storeys',
    'orientation',
    'listingDate',
    'estimatedRates',
    'estimatedRentalReturns',
    'estimatedOwnerCorporationFees',
    'stampDuty',
    'councilFee',
    'floorPlan',
    'terms',
  ];
  total: any;
  page: any;
  pageSize = 5;
  // galleryThumbs: Swiper;
  // galleryTop: Swiper;
  productColumns = ['unit', 'level', 'price'];
  products = [];
  address = '';
  incentives = '';
  propertyDeposit = '';
  headerLeft = 0;
  // 是否在修改project
  isEditProject = false;
  customStyles = [
    {
      featureType: 'road.highway',
      elementType: 'geometry.stroke',
      stylers: [
        {
          color: '#ffffff',
        },
      ],
    },
    {
      featureType: 'road.highway',
      elementType: 'geometry.fill',
      stylers: [
        {
          color: '#ffffff',
        },
      ],
    },
    {
      featureType: 'landscape',
      elementType: 'geometry',
      stylers: [
        {
          color: '#E5E5E5',
        },
        {
          lightness: 20,
        },
      ],
    },
    {
      featureType: 'water',
      elementType: 'geometry',
      stylers: [
        {
          color: '#9CBAD8',
        },
        {
          lightness: 17,
        },
      ],
    },
    {
      featureType: 'poi',
      stylers: [{visibility: 'off'}],
    },
    {
      featureType: 'transit',
      elementType: 'labels.icon',
      stylers: [{visibility: 'off'}],
    },
    {
      featureType: 'road',
      elementType: 'labels',
      stylers: [{visibility: 'off'}],
    },
  ];
  floorPlan: any;
  dataSourceForProject: any;
  dataSourceForTerms: any;
  dataSourceForEoi: any[] = [];
  keywords = '';
  isFiltered = false;
  statuses = [
    {
      id: -2,
      name: 'Invisible',
    },
    {
      id: -1,
      name: 'Under Approval',
    },
    {
      id: 0,
      name: 'Disabled',
    },
    {
      id: 1,
      name: 'Enable',
    },
  ];
  satusShow = '';
  showEois = true;
  floorplanShow = true;
  availableNum = 0;
  soldNum = 0;
  reserveNum = 0;

  constructor(
    private route: ActivatedRoute,
    public tabService: ProjectDetailTabService,
    private router: Router,
    private dialog: MatDialog,
    private httpService: HttpService,
    private location: Location
  ) {
    this.mode = 'table';
  }


  @HostListener('window:resize')
  onResize() {
    this.calculateHeaderLeft();
  }

  // Navigate back
  goBack() {
    if (window && window.history && window.history.length > 1) {
      this.location.back();
    } else {
      this.router.navigate(['/projects']);
    }
  }

  // 顶部是 fixed 的，自适应需要修改一下 left
  calculateHeaderLeft() {
    const screenWidth = window.innerWidth;
    if (screenWidth > 1280) {
      this.headerLeft = 251;
    } else if (screenWidth > 960) {
      this.headerLeft = 88;
    } else {
      this.headerLeft = 0;
    }
  }

  getProjects(): void {
    this.projectId = this.route.snapshot.paramMap.get('id');
    this.project$ = this.httpService
      .getProjectDetailByProjectId(this.projectId)
      .pipe(
        map((res: any) => {
          if (res.code === 1) {
            this.project = res.data;
            this.availableNum = this.project.availableNum ? this.project.availableNum : 0;
            this.soldNum = this.project.soldNum ? this.project.soldNum : 0;
            this.reserveNum = this.project.reserveNum ? this.project.reserveNum : 0;
            this.statuses.forEach((item) => {
              if (item.id === this.project.status) {
                this.satusShow = item.name;
              }
            });
            this.momentDate = moment(this.project.updateTime).format(
              'D MMM,YYYY'
            ); // 2014-09-24 23:36:09
            this.dataSourceForTerms = this.project.termFiles;
            this.dataSourceForProject = this.project.documentFiles;
            if (this.project.eoiFile) {
              this.dataSourceForEoi.push(this.project.eoiFile);
            }

            // 兼容老数据，没有 building 的project，添加一个默认的
            if (
              (this.project.properties && this.project.properties.length > 0) ||
              (this.project.lots && this.project.lots.length > 0) ||
              (this.project.projectTypes[0].id === 4 && !this.project.buildings)
            ) {
              const fakeBuilding = JSON.parse(JSON.stringify(this.project));
              // fakeBuilding.name = 'Main';
              this.project.buildings = this.project.buildings
                ? [fakeBuilding].concat(this.project.buildings)
                : [fakeBuilding];
            }

            this.address = [
              this.project.addressLine2,
              this.project.addressLine1,
            ]
              .filter((address) => address)
              .join(',');
            this.incentives = this.project.incentive
              ? this.project.incentive
                .filter((incentive) => incentive)
                .join(',')
              : '';

            if (res.data.buildings) {
              const properties = [].concat(
                ...res.data.buildings.map((building) => {
                  return building.properties ? building.properties : [];
                })
              );

              const productConfigSet = new Set();
              // 找到所有property的 reserveAmount , 显示在 Holding deposit
              const propertyDepositSet = new Set();

              properties.forEach((property) => {
                productConfigSet.add(
                  [
                    property.bedRoom,
                    property.bathRoom,
                    property.carParking,
                  ].join('-')
                );
                propertyDepositSet.add(
                  'A$' + property.reserveAmount.toLocaleString()
                );
              });

              this.propertyDeposit = Array.from(propertyDepositSet).join('; ');

              // 整理 Product 数据
              productConfigSet.forEach((productKey) => {
                const [bedRoom, bathRoom, carParking] = (productKey as string)
                  .split('-')
                  .map(Number);

                const configProperties = properties.filter((property) => {
                  return (
                    property.bedRoom === bedRoom &&
                    property.bathRoom === bathRoom &&
                    property.carParking === carParking
                  );
                });

                const totalAreaArray = configProperties.map((property) => {
                  return property.totalArea ? property.totalArea : 0;
                });
                const priceArray = configProperties.map((property) => {
                  return property.price ? property.price : 0;
                });

                this.products.push({
                  bedRoom,
                  bathRoom,
                  carParking,
                  minTotalArea: Math.min(...totalAreaArray) || 0,
                  maxTotalArea: Math.max(...totalAreaArray) || 0,
                  minPrice: Math.min(...priceArray) || 0,
                  maxPrice: Math.max(...priceArray) || 0,
                });

                this.products.sort(
                  (a, b) =>
                    a.bedRoom - b.bedRoom ||
                    a.bathRoom - b.bathRoom ||
                    a.carParking - b.carParking
                );
              });
            }

            return res.data;
          } else {
            this.router.navigateByUrl('/projects');
            return null;
          }
        })
      );
  }

  ngOnInit(): void {
    this.getProjects();
  }

  ngAfterViewInit(): void {
    this.calculateHeaderLeft();
    const tabIndex = this.route.snapshot.paramMap.get('tabIndex');
    // Set tab selected index
    if (tabIndex !== null) {
      Promise.resolve().then(() => (this.tabGroup.selectedIndex = +tabIndex));
    }
  }

  uploadPic(res) {
    if (res?.value === true) {
      this.ngOnInit();
    }
  }

  openLink(link) {
    if (!link) return;
    const trimmed = String(link).trim();
    const lower = trimmed.toLowerCase();
    const hasProtocol = lower.startsWith('http://') || lower.startsWith('https://');
    const finalUrl = hasProtocol ? trimmed : `http://${trimmed}`;
    window.open(finalUrl, '_blank', 'noopener');
  }

  // 添加 property
  openAddDialog() {
    const dialogRef = this.dialog.open(AddPropertyDialogComponent, {
      width: '800px',
      height: '800px',
      data: {project: this.project},
    });

    dialogRef.afterClosed().subscribe((result: any) => {
      if (result) {
        this.ngOnInit();
        if (!result.flag) {
          this.openAddDialog();
        }
      }
    });
  }

  changeMode(event) {
    this.mode = event.value;
  }

  // 修改project
  editProject() {
    // this.tabService.tabIndex = 0;
    // this.isEditProject = true;
    const dialogRef = this.dialog.open(EditProjectComponent, {
      width: '816px',
      height: '800px',
      data: {project: this.project},
    });

    dialogRef.afterClosed().subscribe((result: any) => {
      if (result) {
        this.ngOnInit();
      }
    });
  }

  cancelEditProject() {
    this.isEditProject = false;
  }

  // review 更新时间
  openManulUpdateDialog() {
    const dialogRef = this.dialog.open(ManualUpdateDialogComponent, {
      width: '30%',
      data: {project: this.project},
    });
    dialogRef.afterClosed().subscribe((result: any) => {
      if (result) {
        this.ngOnInit();
      }
    });
  }

  selectChange() {
    if (this.tabService.tabIndex === 2) {
      this.floorplanShow = false;
      setTimeout(() => {
        this.floorplanShow = true;
      }, 500);
    }
  }

  // 打开图片预览
  openPhotoDialog() {
    const dialogRef = this.dialog.open(PhotoDialogComponent, {
      maxWidth: '100vw',
      maxHeight: '100vh',
      height: '100%',
      width: '100%',
      data: {project: this.project},
    });
  }

  openVrLink() {
    if (this.project?.vrURLs) {
      this.openLink(this.project.vrURLs);
    }
  }

  openVideoDialog() {
    const dialogRef = this.dialog.open(VideoDialogComponent, {
      maxWidth: '100vw',
      maxHeight: '100vh',
      height: '100%',
      width: '100%',
      data: {videoURL: this.project.videoURL},
    });
  }

  // 点击floorplan tab 的时候，floorplan 从详情回到列表
  floorplanReset() {
    this.FloorplansComponent.resetFloorplan();
  }

  // 修改 / 创建 floorplan
  openEditFloorPlanDialog(isEdit = false, step = 0) {
    const dialogRef = this.dialog.open(EditFloorplanDialogComponent, {
      width: '650px',
      height: 'auto',
      autoFocus: false,
      data: {
        floorPlan: this.floorPlan,
        project: this.project,
        isEdit, // 是否是修改
        step,
      },
    });
    dialogRef.afterClosed().subscribe((result: any) => {
      if (result) {
        this.ngOnInit();
      }
    });
  }

  formatNum(value) {
    // var num = 0
    // if (!value && value == 0) {
    //   num = 0
    // } else {
    //   let str = value.toString();
    //   let reg = str.indexOf(".") > -1 ? /(\d)(?=(\d{3})+\.)/g : /(\d)(?=(?:\d{3})+$)/g;
    //   num = str.replace(reg, "$1,");
    // }
    // return num
    if (value === null || value === undefined) {
      return '0';
    }
    if (value === 0) {
      return '0';
    }
    const str = value.toString();
    const reg = /\B(?=(\d{3})+(?!\d))/g;
    return str.replace(reg, ',');
  }

  addEoi() {
    // this.eoi = "add"
    const dialogRef = this.dialog.open(AddEoiDialog, {
      width: '60%',
      disableClose: true,
      data: {
        project: this.project,
      },
    });

    dialogRef.afterClosed().subscribe((result: any) => {


      if (result) {
        this.showEois = false;
        setTimeout(() => {
          this.showEois = true;
        }, 500);
      }
    });
  }

  openAddDocumentDialog() {

    this.ngOnInit();

    const dialogRef = this.dialog.open(AddDocumentDialogComponent, {
      width: '800px',
      data: {project: this.project},
    });

    dialogRef.componentInstance.onUpdate.subscribe((data) => {
      if (data) {

        this.ngOnInit();
        // if (data.documentFiles) {
        //     this.project.documentFiles = data.documentFiles;
        // }

        // if (data.termFiles) {
        //     this.project.termFiles = data.termFiles;
        // }

        // if (data.eoiFiles) {
        //     this.project.eoiFile = data.eoiFiles;
        // }

        this.filterData();
      }
    });
  }

  handleAddLot() {
    const dialogRef = this.dialog.open(AddLotDialogComponent, {
      width: '800px',
      data: {project: this.project},
    });
    dialogRef.afterClosed().subscribe((result: any) => {
      if (result) {
        this.ngOnInit();
      }
    });
  }

  addBuildingType() {
    const dialogRef = this.dialog.open(NewPackagesComponent, {
      width: '80%',
      data: {
        projectId: this.project.id,
      },
    });

    dialogRef.afterClosed().subscribe((result: any) => {
      if (result) {
        this.ngOnInit();
      }
    });
  }

  filterData() {
    this.dataSourceForProject = this.project.documentFiles.filter((file) => {
      return file.fileName.toLowerCase().includes(this.keywords.toLowerCase());
    });
    this.dataSourceForTerms = this.project.termFiles.filter((file) => {
      return file.fileName.toLowerCase().includes(this.keywords.toLowerCase());
    });
    this.dataSourceForEoi = [];
    if (
      this.project.eoiFile &&
      this.project.eoiFile.fileName
        .toLowerCase()
        .includes(this.keywords.toLowerCase())
    ) {
      this.dataSourceForEoi.push(this.project.eoiFile);
    }

    this.isFiltered = this.keywords !== '';
  }

  /**
   * @author Damon Gao
   * @description handel the price display logic
   */
  getPriceDisplay(): string {
    const min = this.project?.minPrice ?? 0;
    const max = this.project?.maxPrice ?? 0;
    if (max !== 0 && min !== 0) {
      return `$${this.formatNum(min)} - $${this.formatNum(max)}`;
    } else if (max === 0 && min !== 0) {
      return `From $${this.formatNum(min)}`;
    } else if (max !== 0 && min === 0) {
      return `Up to $${this.formatNum(max)}`;
    }
    return '-';
  }

  trackByIdx(index: number): number {
    return index;
  }
}
